/* ============================================================
   STICKEREI-KARTE
   Reines Vanilla JS, keine Abhaengigkeiten.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('stickerei-karte');
  if (!root) return;

  var CFG = JSON.parse(root.dataset.config);

  /* ---------- Konstanten ----------
     CAP_RATIO  : Versalhoehe geteilt durch font-size
     LINE_PITCH : Grundlinienabstand als Vielfaches der Versalhoehe
     DESCENDER  : Unterlaenge unter der Grundlinie
     Alle drei nach einem Probestick nachmessen und ggf. korrigieren. */
  var CAP_RATIO  = 0.70;
  var LINE_PITCH = 1.25;
  var DESCENDER  = 0.22;

  var ORDER = ['vorne', 'hinten', 'links', 'rechts'];
  var AKTIV = ORDER.filter(function (p) { return CFG.positionen.indexOf(p) !== -1; });

  var ctx = document.createElement('canvas').getContext('2d');

  /* ---------- Zustand ----------
     Start-Beispieltext "TEXT" + erste Schrift schon ausgewaehlt. Nur
     die erste Zeile wird vorbelegt; weitere erlaubte Zeilen bleiben
     leer und koennen optional genutzt werden. Der Wert ist absichtlich
     kein Placeholder, deshalb wird er beim Fokus komplett markiert. */
  var STANDARD_TEXT = 'TEXT';
  var STANDARD_SCHRIFT = CFG.schriften[0] ? CFG.schriften[0].id : null;

  var state = { gewaehlt: {}, daten: {} };
  AKTIV.forEach(function (p, i) {
    state.gewaehlt[p] = (i === 0);
    var a = CFG.flaechen[p];
    var zeilen = ['', '', ''];
    zeilen[0] = STANDARD_TEXT;
    /* "text" ist die tatsaechliche Rohfassung mit Zeilenumbruechen, wie
       sie im Textfeld steht - einzige Quelle fuer den angezeigten Wert.
       "zeilen" bleibt daraus ABGELEITET, nur fuer die bestehende
       Breitenpruefung je Zeile. Ohne diese Trennung musste ta.value
       aus dem festen 3er-Array per join() rekonstruiert werden - das
       erzeugte IMMER 2 Zeilenumbrueche (Laenge des Arrays minus 1),
       auch wenn erst 1-2 Zeilen tatsaechlich benutzt wurden. Bug,
       27.09.2026 vom Nutzer gemeldet: eine gerade per Enter neu
       begonnene Zeile wurde beim Neuzeichnen dadurch verdoppelt. */
    state.daten[p] = { text: STANDARD_TEXT, zeilen: zeilen, schrift: STANDARD_SCHRIFT, groesse: a.min };
  });

  /* Bildquelle ----------
     Falls fuer die Position "vorne" ein Farbfoto hinterlegt ist
     (CFG.farbFotos, z.B. bei der Tasche mit 12 Farben), wird dieses
     verwendet. Ansonsten greift das normale Foto.
     Farbfotos gelten nur fuer die Position "vorne" - fuer
     Hinten/Links/Rechts werden immer die neutralen Seitenfotos
     verwendet, da keine farbspezifischen Seitenfotos vorliegen. */
  function fotoQuelle(foto, position) {
    if (!foto) return null;
    /* Taschen: Hinten zeigt dasselbe Farbfoto wie Vorne (Narin, Okt. 2026). */
    var istTasche = CFG.stickTyp === 'tasche' || CFG.stickTyp === 'shopper' || CFG.stickTyp === 'tote';
    if ((position === 'vorne' || (istTasche && position === 'hinten')) && CFG.farbFotos && CFG.farbFotos[CFG.farbeAktuell]) {
      return CFG.farbFotos[CFG.farbeAktuell];
    }
    return foto.src;
  }

  /* Liest die gerade am Produkt gewaehlte erste Variantenoption (bei
     uns immer die Farbe) direkt aus Dawns <variant-selects> - gleiche
     Abfrage wie Dawns eigene VariantSelects.getAllSelectedOptions() in
     global.js, damit es sowohl bei Swatches/Buttons (fieldset) als
     auch bei Dropdowns (.product-form__input--dropdown) funktioniert.
     Baugleich mit wunschlogo-karte.js. */
  function aktuelleFarbe() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return CFG.farbeAktuell;
    var gruppe = vs.querySelector('fieldset, .product-form__input--dropdown');
    if (!gruppe) return CFG.farbeAktuell;
    var gewaehlt = gruppe.querySelector('input:checked') || gruppe.querySelector('select option[selected]');
    return gewaehlt ? gewaehlt.value : CFG.farbeAktuell;
  }

  /* ---------- Rechenkern ---------- */
  /* Baut den Canvas-/CSS-font-String inkl. Schriftschnitt (fuer Fett/Kursiv-
     Varianten wie "Arimo Bold Italic" - ohne das misst breiteCm() mit dem
     falschen, meist schmaleren Schnitt und die Breitenpruefung wird falsch). */
  function schriftSchnitt(font) {
    var gewicht = (font.weight && font.weight !== '400') ? font.weight + ' ' : '';
    var stil = (font.style && font.style !== 'normal') ? font.style + ' ' : '';
    return stil + gewicht;
  }
  function breiteCm(text, font, capCm) {
    if (!text || !font) return 0;
    if (font.css) {
      ctx.font = schriftSchnitt(font) + '100px ' + font.css;
      return (ctx.measureText(text).width / 100) * (capCm / CAP_RATIO);
    }
    return text.length * font.faktor * capCm;
  }
  function hoeheCm(n, capCm) {
    return ((n - 1) * LINE_PITCH + 1 + DESCENDER) * capCm;
  }
  function maxGroesseFuerZeilen(n, a) {
    var passt = a.h / ((n - 1) * LINE_PITCH + 1 + DESCENDER);
    return Math.min(a.max, Math.max(a.min, Math.floor(passt * 10) / 10));
  }
  function maxZeichen(text, font, capCm, maxW) {
    var n = text.length;
    while (n > 0 && breiteCm(text.slice(0, n), font, capCm) > maxW) n--;
    return n;
  }
  function maxGroesseFuerBreite(text, font, a, deckel) {
    for (var v = deckel; v >= a.min; v = Math.round((v - 0.1) * 10) / 10) {
      if (breiteCm(text, font, v) <= a.w) return v;
    }
    return null;
  }
  function groessenwort(cm) {
    if (cm < 1.25) return 'klein';
    if (cm < 1.75) return 'mittel';
    if (cm < 2.25) return 'groß';
    if (cm < 3.00) return 'sehr groß';
    return 'extra groß';
  }
  function komma(n, k) { return n.toFixed(k === undefined ? 1 : k).replace('.', ','); }

  /* ---------- Skizzen ---------- */
  var SVG = {
    vorne: '<svg viewBox="0 0 120 92" aria-hidden="true">' +
      '<path class="sk-cap" d="M22 60 A38 40 0 0 1 98 60 Z"/>' +
      '<path class="sk-cap" d="M60 20 L60 60"/>' +
      '<path class="sk-cap" d="M20 60 C22 80 98 80 100 60"/>' +
      '<rect class="sk-area" x="34" y="36" width="52" height="18" rx="2"/></svg>',
    hinten: '<svg viewBox="0 0 120 92" aria-hidden="true">' +
      '<path class="sk-cap" d="M22 60 A38 40 0 0 1 98 60"/>' +
      '<path class="sk-cap" d="M22 60 L50 60 M70 60 L98 60"/>' +
      '<path class="sk-cap" d="M50 60 L50 48 M70 60 L70 48"/>' +
      '<path class="sk-cap" d="M46 52 L74 52"/>' +
      '<rect class="sk-area" x="36" y="28" width="48" height="15" rx="2"/></svg>',
    links: '<svg viewBox="0 0 120 92" aria-hidden="true">' +
      '<path class="sk-cap" d="M30 62 A34 38 0 0 1 96 62 Z"/>' +
      '<path class="sk-cap" d="M96 62 C112 62 116 72 108 76 L92 71"/>' +
      '<rect class="sk-area" x="46" y="42" width="30" height="15" rx="2"/></svg>',
    rechts: '<svg viewBox="0 0 120 92" aria-hidden="true"><g transform="translate(120,0) scale(-1,1)">' +
      '<path class="sk-cap" d="M30 62 A34 38 0 0 1 96 62 Z"/>' +
      '<path class="sk-cap" d="M96 62 C112 62 116 72 108 76 L92 71"/>' +
      '<rect class="sk-area" x="46" y="42" width="30" height="15" rx="2"/></g></svg>'
  };

  /* Die Positionskachel "Vorne" zeigt die echte Produktform statt
     pauschal eine Kappe. Andere Positionen behalten ihre vorhandenen
     Kappenansichten, da Socke/Muetze/Tasche aktuell nur vorne erlauben. */
  var PRODUKT_SVG = {
    socke: '<svg viewBox="0 0 120 92" aria-hidden="true">' +
      '<path class="sk-cap" d="M43 10 H72 V49 C72 58 78 63 88 64 L100 66 C106 67 107 73 101 77 C88 86 69 85 58 77 C49 70 44 61 43 51 Z"/>' +
      '<path class="sk-cap" d="M43 19 H72 M43 24 H72"/>' +
      '<rect class="sk-area" x="50" y="29" width="16" height="24" rx="2"/></svg>',
    tasche: '<svg viewBox="0 0 120 92" aria-hidden="true">' +
      '<path class="sk-cap" d="M29 31 H91 L86 79 H34 Z"/>' +
      '<path class="sk-cap" d="M43 31 C43 13 77 13 77 31"/>' +
      '<rect class="sk-area" x="42" y="45" width="36" height="22" rx="2"/></svg>',
    muetze: '<svg viewBox="0 0 120 92" aria-hidden="true">' +
      '<path class="sk-cap" d="M34 57 C34 30 45 17 60 17 C75 17 86 30 86 57"/>' +
      '<path class="sk-cap" d="M31 56 H89 V77 H31 Z"/>' +
      '<path class="sk-cap" d="M60 17 V56"/>' +
      '<rect class="sk-area" x="41" y="61" width="38" height="11" rx="2"/></svg>',
    shopper: '<svg viewBox="0 0 120 92" aria-hidden="true">' +
      '<path class="sk-cap" d="M29 33 H91 L87 80 H33 Z"/>' +
      '<path class="sk-cap" d="M43 33 C43 13 77 13 77 33"/>' +
      '<path class="sk-cap" d="M44 47 H76 V74 H44"/>' +
      '<rect class="sk-area" x="46" y="49" width="28" height="23" rx="2"/></svg>',
    tote: '<svg viewBox="0 0 120 92" aria-hidden="true">' +
      '<path class="sk-cap" d="M24 34 H96 L91 80 H29 Z"/>' +
      '<path class="sk-cap" d="M38 34 C38 12 53 12 53 34"/>' +
      '<path class="sk-cap" d="M67 34 C67 12 82 12 82 34"/>' +
      '<rect class="sk-area" x="40" y="46" width="40" height="24" rx="2"/></svg>'
  };

  function positionsSkizze(p) {
    /* Taschen: Vorne UND Hinten zeigen dasselbe Taschen-Symbol (Narin, Oktober 2026). */
    var tasche = CFG.stickTyp === 'tasche' || CFG.stickTyp === 'shopper' || CFG.stickTyp === 'tote';
    return ((p === 'vorne' || (tasche && p === 'hinten')) && PRODUKT_SVG[CFG.stickTyp]) ? PRODUKT_SVG[CFG.stickTyp] : SVG[p];
  }

  function zeichneSkizzen() {
    var host = document.getElementById('sk-sketches');
    host.innerHTML = '';
    host.style.gridTemplateColumns = 'repeat(' + Math.min(AKTIV.length, 4) + ',1fr)';
    AKTIV.forEach(function (p) {
      var a = CFG.flaechen[p];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sk-tile';
      b.setAttribute('aria-pressed', state.gewaehlt[p]);
      b.innerHTML = '<span class="sk-tick">✓</span>' + positionsSkizze(p) +
        '<span class="sk-n">' + a.kurz + '</span>' +
        '<span class="sk-d">' + a.w + '×' + komma(a.h) + ' cm</span>';
      b.addEventListener('click', function () { umschalten(p); });
      host.appendChild(b);
    });
  }

  function anzahlGewaehlt() {
    return AKTIV.filter(function (p) { return state.gewaehlt[p]; }).length;
  }

  function umschalten(p) {
    if (state.gewaehlt[p]) {
      if (anzahlGewaehlt() === 1) return;   // mindestens eine Position
      state.gewaehlt[p] = false;
    } else {
      state.gewaehlt[p] = true;
    }
    varianteSetzen();
    alles();
  }

  /* ---------- Variante steuern ----------
     Wir setzen bevorzugt die native Themeauswahl und loesen 'change' aus,
     damit das Theme selbst Preis, Verfuegbarkeit und Varianten-ID aktualisiert.
     Nur wenn das nicht gelingt, setzen wir die ID direkt. */
  function varianteSetzen() {
    var wert = anzahlGewaehlt() === 1 ? '1 Position' : anzahlGewaehlt() + ' Positionen';
    if (nativSetzen(wert)) return;
    fallbackSetzen(wert);
  }

  function nativSetzen(wert) {
    var ok = false;
    document.querySelectorAll(
      'variant-selects input[type=radio], variant-radios input[type=radio], ' +
      '.product-form__input input[type=radio]'
    ).forEach(function (el) {
      if (el.value === wert && !el.checked) { el.checked = true; feuere(el); ok = true; }
      else if (el.value === wert) { ok = true; }
    });
    if (ok) return true;

    document.querySelectorAll('variant-selects select, .product-form__input select')
      .forEach(function (sel) {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === wert) {
            if (sel.value !== wert) { sel.value = wert; feuere(sel); }
            ok = true;
          }
        }
      });
    return ok;
  }

  function feuere(el) {
    el.dispatchEvent(new Event('change', { bubbles: true }));
    el.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function fallbackSetzen(wert) {
    var v = CFG.varianten[CFG.farbeAktuell + '|' + wert];
    if (!v) return;
    var id = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (id) { id.value = v.id; feuere(id); }
  }

  /* ---------- Positionsbloecke ---------- */
  function zeichneBloecke() {
    var host = document.getElementById('sk-blocks');
    host.innerHTML = '';
    AKTIV.filter(function (p) { return state.gewaehlt[p]; })
      .forEach(function (p) { host.appendChild(baueBlock(p)); });
    skaliere();
  }

  function baueBlock(p) {
    var a = CFG.flaechen[p], s = state.daten[p];
    var box = document.createElement('div');
    box.className = 'sk-block';
    /* Fuer die Live-Vorschau im Produktbild (sk-galerie-vorschau.js) -
       damit sie von aussen weiss, welcher Block zu welcher Position
       gehoert, ohne die bestehende Logik hier anzufassen. */
    box.dataset.position = p;

    var h = document.createElement('h4');
    h.innerHTML = a.label + ' <span class="sk-dim">Stickfläche ' + a.w + ' × ' + komma(a.h) +
      ' cm · max. ' + a.zeilen + (a.zeilen === 1 ? ' Zeile' : ' Zeilen') + '</span>';
    box.appendChild(h);

    /* Text: EIN Feld statt einzelner Zeilen-Inputs - Enter erzeugt eine
       neue Zeile, bis zur je Position erlaubten Zeilenzahl (a.zeilen).
       state.daten[p].zeilen bleibt intern unveraendert ein Array (fuer
       die restliche Rechenlogik/Breitenpruefung je Zeile) - wird hier
       nur beim Tippen aus dem Textfeld-Wert neu befuellt bzw. beim
       Anzeigen wieder zu einem Text mit Zeilenumbruechen zusammengesetzt. */
    var maxZeichenGesamt = 40 * a.zeilen;
    var ta = document.createElement('textarea');
    ta.className = 'sk-textarea';
    ta.rows = a.zeilen;
    ta.maxLength = maxZeichenGesamt;
    ta.placeholder = 'Dein Text';
    ta.value = s.text || '';
    ta.dataset.key = p + '-txt';
    ta.addEventListener('focus', function () { ta.select(); });
    ta.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var vorherigeZeilen = ta.value.slice(0, ta.selectionStart).split('\n').length;
      if (vorherigeZeilen >= a.zeilen) e.preventDefault();
    });
    ta.addEventListener('input', function (e) {
      s.text = e.target.value;
      var zeilen = s.text.split('\n').slice(0, a.zeilen);
      for (var z = 0; z < a.zeilen; z++) { s.zeilen[z] = zeilen[z] || ''; }
      alles({ fokus: p + '-txt', pos: ta.selectionStart });
    });
    box.appendChild(ta);

    var c = document.createElement('div');
    c.className = 'sk-count';
    c.textContent = ta.value.length + ' / ' + maxZeichenGesamt;
    box.appendChild(c);

    var zh = document.createElement('p');
    zh.className = 'sk-zeilen-hint';
    zh.textContent = a.zeilen > 1
      ? 'Enter für neue Zeile (max. ' + a.zeilen + ').'
      : 'Nur eine Zeile möglich auf dieser Fläche.';
    box.appendChild(zh);

    /* Schriftkacheln: zeigen den eigenen Text */
    var ersteZeile = (s.zeilen.find(function (t) { return t && t.trim(); }) || '').trim();
    var probe = ersteZeile ? ersteZeile.slice(0, 14) : 'Dein Text';

    var fl = document.createElement('p');
    fl.className = 'sk-label';
    fl.style.marginTop = '8px';
    fl.innerHTML = 'Schriftart <span class="sk-req">*</span>';
    box.appendChild(fl);

    var fg = document.createElement('div');
    fg.className = 'sk-fonts';
    CFG.schriften.forEach(function (f) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sk-font';
      b.setAttribute('aria-pressed', s.schrift === f.id);
      var span = document.createElement('span');
      span.className = 'sk-s';
      span.style.fontFamily = f.css;
      span.style.fontWeight = f.weight || '400';
      span.style.fontStyle = f.style || 'normal';
      span.textContent = probe;                     // kein HTML aus Eingabe
      var lab = document.createElement('span');
      lab.className = 'sk-l';
      lab.textContent = f.name;
      b.appendChild(span); b.appendChild(lab);
      b.addEventListener('click', function () { s.schrift = f.id; alles(); });
      fg.appendChild(b);
    });
    box.appendChild(fg);

    /* Slider: Obergrenze haengt an der Zeilenanzahl UND an der Breite
       des laengsten Textes. Damit der Kunde nie einen Wert waehlen kann,
       bei dem der Text ueber den Stickrahmen hinausragt. */
    var genutzt = s.zeilen.slice(0, a.zeilen).filter(function (t) { return t.trim().length; });
    var nZeilen = Math.max(1, genutzt.length);
    var deckelH = maxGroesseFuerZeilen(nZeilen, a);
    var deckel = deckelH;
    var font = CFG.schriften.filter(function (f) { return f.id === s.schrift; })[0];
    if (genutzt.length && font) {
      genutzt.forEach(function (t) {
        var deckelB = maxGroesseFuerBreite(t, font, a, deckelH);
        if (deckelB !== null && deckelB < deckel) deckel = deckelB;
      });
    }
    if (s.groesse > deckel) s.groesse = deckel;

    var row = document.createElement('div');
    row.className = 'sk-slrow';
    row.innerHTML = '<span class="sk-label" style="margin:0">Schriftgröße</span>' +
      '<span class="sk-slval">' + komma(s.groesse) + ' cm <em>· ' + groessenwort(s.groesse) + '</em></span>';
    box.appendChild(row);
    var slval = row.querySelector('.sk-slval');

    var sl = document.createElement('input');
    sl.type = 'range'; sl.min = a.min; sl.max = deckel; sl.step = 0.1; sl.value = s.groesse;
    sl.addEventListener('input', function (e) { s.groesse = parseFloat(e.target.value); alles(); });
    box.appendChild(sl);

    var ends = document.createElement('div');
    ends.className = 'sk-slends';
    ends.innerHTML = '<span>' + komma(a.min) + ' cm</span><span>' + komma(deckel) + ' cm</span>';
    box.appendChild(ends);

    if (deckel < a.max) {
      var lh = document.createElement('p');
      lh.className = 'sk-hint';
      lh.style.margin = '-6px 0 12px';
      lh.textContent = 'Bei ' + nZeilen + ' Zeilen sind höchstens ' + komma(deckel) +
        ' cm möglich — die Fläche ist ' + komma(a.h) + ' cm hoch.';
      box.appendChild(lh);
    }

    /* Vorschau */
    var font = CFG.schriften.filter(function (f) { return f.id === s.schrift; })[0];
    var foto = CFG.fotos[p];
    var prev = document.createElement('div');
    prev.className = 'sk-prev';
    var ziel;

    if (foto && foto.src) {
      prev.classList.add('sk-photo');
      if (foto.spiegeln) prev.classList.add('sk-flip');
      prev.style.aspectRatio = foto.ratio;
      prev.style.backgroundImage = 'url("' + fotoQuelle(foto, p) + '")';
      prev.dataset.areaw = foto.cmWide;

      var cmHoch = foto.cmWide / foto.ratio;
      var lift = (foto.liftCm || 0) / cmHoch;
      var feld = document.createElement('div');
      /* sk-field--oben/--mitte statt der Ausrichtung ueber einen
         Vorfahren (z.B. #stickerei-karte.sk-typ-socke) zu steuern: Die
         Live-Vorschau im Produktbild (sk-galerie-vorschau.js) KLONT
         dieses Element in einen anderen Teil des DOMs (ausserhalb von
         #stickerei-karte) - eine Vorfahren-Regel wuerde dort nicht
         mehr greifen. Die Klasse direkt am Feld ueberlebt das Klonen. */
      var ausrichtungKlasse = '';
      if (CFG.textAusrichtung === 'oben') ausrichtungKlasse = ' sk-field--oben';
      else if (CFG.textAusrichtung === 'mitte') ausrichtungKlasse = ' sk-field--mitte';
      feld.className = 'sk-field' + ausrichtungKlasse;
      feld.style.width = (a.w / foto.cmWide * 100) + '%';
      feld.style.height = (a.h / cmHoch * 100) + '%';
      feld.style.left = (foto.cx * 100) + '%';
      feld.style.top = ((foto.cy - lift) * 100) + '%';
      prev.appendChild(feld);
      ziel = feld;
    } else {
      prev.style.aspectRatio = a.w + ' / ' + a.h;
      prev.dataset.areaw = a.w;
      ziel = prev;
    }

    var zuBreit = null;
    if (genutzt.length && font) {
      genutzt.forEach(function (t) {
        var w = breiteCm(t, font, s.groesse);
        if (w > a.w && (!zuBreit || w > zuBreit.w)) zuBreit = { t: t, w: w };
      });
      var inner = document.createElement('div');
      inner.className = 'sk-txt';
      inner.style.fontFamily = font.css;
      inner.style.fontWeight = font.weight || '400';
      inner.style.fontStyle = font.style || 'normal';
      inner.style.lineHeight = (LINE_PITCH * CAP_RATIO).toFixed(3);
      inner.style.color = garnFarbe() || 'currentColor';
      inner.dataset.size = s.groesse;
      inner.textContent = genutzt.join('\n');
      ziel.appendChild(inner);
      aktiviereTextGriff(inner, ziel, a, s, nZeilen, deckel, sl, slval);
    } else {
      var e = document.createElement('span');
      e.className = 'sk-empty';
      e.textContent = !genutzt.length ? 'Text eingeben' : 'Schriftart wählen';
      prev.appendChild(e);
    }
    if (zuBreit) prev.classList.add('sk-bad');
    box.appendChild(prev);

    if (zuBreit) {
      var passt = maxZeichen(zuBreit.t, font, s.groesse, a.w);
      var kleiner = maxGroesseFuerBreite(zuBreit.t, font, a, deckel);
      var w = document.createElement('div');
      w.className = 'sk-warn';
      w.innerHTML = 'Zu breit für ' + a.w + ' cm — gebraucht werden ' + komma(zuBreit.w) + ' cm.<br>' +
        (kleiner ? 'Größe auf ' + komma(kleiner) + ' cm reduzieren' : 'Größe reduzieren') +
        ' oder auf ' + passt + ' Zeichen kürzen.';
      box.appendChild(w);
      s._zuBreit = true;
    } else {
      s._zuBreit = false;
      if (genutzt.length && font) {
        var laengste = genutzt.reduce(function (m, t) {
          return Math.max(m, breiteCm(t, font, s.groesse));
        }, 0);
        var o = document.createElement('div');
        o.className = 'sk-ok';
        o.textContent = 'Passt — ' + komma(laengste) + ' × ' + komma(hoeheCm(genutzt.length, s.groesse)) +
          ' cm von ' + a.w + ' × ' + komma(a.h) + ' cm belegt' + (font.css ? '.' : ' (geschätzt).');
        box.appendChild(o);
      }
    }
    return box;
  }

  /* Ziehgriff an der Text-Vorschau, analog zum Motiv-Griff bei DTF
     (dtf-optionen.js). Waehrend des Ziehens wird NICHT alles()/
     zeichneBloecke() aufgerufen (das wuerde den Block inkl. Griff neu
     aufbauen und die laufende Drag-Geste kappen) - nur Schriftgroesse,
     Schriftgroesse-Style und die line item properties werden live
     aktualisiert. Deckel/Zeilenumbruch-Warnung etc. werden erst beim
     Loslassen ueber alles() final nachgezogen. */
  function aktiviereTextGriff(textEl, feldEl, a, s, nZeilen, deckel, sl, slval) {
    var griff = document.createElement('button');
    griff.type = 'button';
    griff.className = 'sk-resize-handle';
    griff.setAttribute('aria-label', 'Schriftgröße durch Ziehen ändern');
    griff.title = 'Ziehen, um die Schriftgröße zu ändern';
    griff.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 20L20 4M20 4h-6M20 4v6M4 20h6M4 20v-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    textEl.appendChild(griff);

    griff.addEventListener('pointerdown', function (start) {
      start.preventDefault();
      start.stopPropagation();
      var prev = textEl.closest('.sk-prev');
      var ppc = prev.clientWidth / parseFloat(prev.dataset.areaw);
      if (!ppc) return;
      var unten = feldEl.getBoundingClientRect().bottom;
      var k = (nZeilen - 1) * LINE_PITCH + 1 + DESCENDER;
      try { griff.setPointerCapture(start.pointerId); } catch (err) {}
      prev.classList.add('sk-prev--resizing');

      function bewegen(e) {
        var hoeheCmZiel = (unten - e.clientY) / ppc;
        var neu = hoeheCmZiel / k;
        neu = Math.min(deckel, Math.max(a.min, Math.round(neu * 10) / 10));
        if (neu === s.groesse) return;
        s.groesse = neu;
        textEl.dataset.size = neu;
        textEl.style.fontSize = (neu / CAP_RATIO * ppc) + 'px';
        if (sl) sl.value = neu;
        if (slval) slval.innerHTML = komma(neu) + ' cm <em>· ' + groessenwort(neu) + '</em>';
        schreibeProperties();
        pruefe();
      }

      function ende() {
        prev.classList.remove('sk-prev--resizing');
        griff.removeEventListener('pointermove', bewegen);
        griff.removeEventListener('pointerup', ende);
        griff.removeEventListener('pointercancel', ende);
        alles();
      }

      griff.addEventListener('pointermove', bewegen);
      griff.addEventListener('pointerup', ende);
      griff.addEventListener('pointercancel', ende);
    });
  }

  /* Massstab: erst nach dem Einhaengen kennen wir die Pixelbreite */
  function skaliere() {
    root.querySelectorAll('.sk-prev').forEach(function (prev) {
      var ppc = prev.clientWidth / parseFloat(prev.dataset.areaw);
      var t = prev.querySelector('.sk-txt');
      if (t) t.style.fontSize = (parseFloat(t.dataset.size) / CAP_RATIO * ppc) + 'px';
    });
  }
  window.addEventListener('resize', skaliere);

  /* ---------- Garnfarbe aus deinem bestehenden Picker lesen ----------
     Erwartet ein Feld  name="properties[Garnfarbe]".
     Fuer die Textfarbe braucht es zusaetzlich data-garn-hex="#rrggbb"
     am gewaehlten Element (unser Garnfarben-Picker liefert das automatisch). */
  function garnFeld() {
    return root.querySelector('[name="properties[Garnfarbe]"]');
  }
  function garnWert() {
    var f = garnFeld();
    return f && f.value ? f.value : '';
  }
  function garnFarbe() {
    var gew = root.querySelector(
      '[data-garn-hex][aria-checked="true"], [data-hex][aria-pressed="true"], [data-hex].is-selected, [data-hex]:checked'
    );
    if (!gew) return null;
    return gew.dataset.garnHex || gew.dataset.hex || null;
  }
  root.addEventListener('change', function (e) {
    if (e.target.closest('.sk-yarn')) alles();
  });
  root.addEventListener('click', function (e) {
    if (e.target.closest('.sk-yarn')) setTimeout(alles, 0);
  });

  /* ---------- Properties + Pruefung ---------- */
  function schreibeProperties() {
    var host = document.getElementById('sk-props');
    host.innerHTML = '';
    var gewaehlte = AKTIV.filter(function (p) { return state.gewaehlt[p]; });

    feld(host, 'Positionen', gewaehlte.map(function (p) { return CFG.flaechen[p].kurz; }).join(' + '));

    gewaehlte.forEach(function (p) {
      var a = CFG.flaechen[p], s = state.daten[p];
      var f = CFG.schriften.filter(function (x) { return x.id === s.schrift; })[0];
      var txt = s.zeilen.slice(0, a.zeilen).filter(function (t) { return t.trim(); }).join(' | ');
      feld(host, a.label + ' — Text', txt);
      feld(host, a.label + ' — Schriftart', f ? f.name : '');
      feld(host, a.label + ' — Größe', komma(s.groesse) + ' cm');
    });
  }
  function feld(host, name, wert) {
    var i = document.createElement('input');
    i.type = 'hidden';
    i.name = 'properties[' + name + ']';
    i.value = wert;
    host.appendChild(i);
  }

  function pruefe() {
    var probleme = [];
    AKTIV.filter(function (p) { return state.gewaehlt[p]; }).forEach(function (p) {
      var a = CFG.flaechen[p], s = state.daten[p];
      var hatText = s.zeilen.slice(0, a.zeilen).some(function (t) { return t.trim(); });
      if (!hatText) probleme.push(a.label + ': Text fehlt');
      else if (!s.schrift) probleme.push(a.label + ': Schriftart fehlt');
      else if (s._zuBreit) probleme.push(a.label + ': Text passt nicht in die Fläche');
    });
    if (!garnWert()) probleme.push('Garnfarbe fehlt');

    var ul = document.getElementById('sk-blockers');
    ul.innerHTML = probleme.map(function (t) { return '<li>' + t + '</li>'; }).join('');

    /* Steckt diese Karte in einem gerade ausgeblendeten
       Veredelungs-Umschalter-Panel (veredelung-auswahl.liquid, Fall
       "Stickerei + DTF"), zaehlt ihre Pruefung nicht - sonst blockiert
       die unsichtbare Karte den Kauf ueber die andere Veredelungsart. */
    var eigenesPanel = root.closest('.va-panel');
    if (!(eigenesPanel && eigenesPanel.hidden)) {
      document.querySelectorAll(
        'form[action*="/cart/add"] [type=submit], form[action*="/cart/add"] .product-form__submit'
      ).forEach(function (btn) { btn.disabled = probleme.length > 0; });
    }

    return probleme.length === 0;
  }

  /* Letzte Sperre: Absenden verhindern, falls etwas fehlt */
  var form = document.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!pruefe()) {
        e.preventDefault();
        e.stopPropagation();
        document.getElementById('sk-blockers').scrollIntoView({ block: 'center' });
      }
    }, true);
  }

  /* ---------- Render ---------- */
  function alles(opt) {
    opt = opt || {};
    zeichneSkizzen();
    zeichneBloecke();
    schreibeProperties();
    pruefe();
    if (opt.fokus) {
      var el = root.querySelector('[data-key="' + opt.fokus + '"]');
      if (el) {
        var pos = opt.pos === undefined ? el.value.length : opt.pos;
        el.focus();
        el.setSelectionRange(pos, pos);
      }
    }
    /* Eigenes Ereignis, zusaetzlich zu den nativen input/change/click,
       auf die sk-galerie-vorschau.js lauscht - siehe ausfuehrlichen
       Kommentar zum baugleichen Fix in wunschlogo-karte.js (dort wegen
       asynchroner Bildverarbeitung beim Logo-Upload noetig; hier vor
       allem fuer den asynchronen document.fonts.ready-Aufruf unten). */
    root.dispatchEvent(new CustomEvent('lc-alles', { bubbles: true }));
  }

  /* Fehlte bisher komplett (21. September 2026): CFG.farbeAktuell wurde
     nur einmal beim Laden der Seite gesetzt, nie danach - ein
     Farbfoto-Wechsel (CFG.farbFotos) hat den Kunden also nie erreicht,
     wenn er die Variantenfarbe NACH dem Laden umgestellt hat. Die
     Variantenauswahl liegt ausserhalb von #stickerei-karte (in
     buy-buttons.liquid), deshalb hier am document lauschen statt am
     eigenen root. Baugleich mit wunschlogo-karte.js. */
  document.addEventListener('change', function (e) {
    if (!e.target.closest('variant-selects')) return;
    var neu = aktuelleFarbe();
    if (neu === CFG.farbeAktuell) return;
    CFG.farbeAktuell = neu;
    alles();
  });

  /* Fuer die grosse Live-Vorschau im Produktbild (sk-galerie-vorschau.js,
     eigene Datei/Closure ohne Zugriff auf state/CFG hier): baut dort auf
     der GEKLONTEN Vorschau denselben Ziehgriff wie auf der kleinen Karte
     nach. Der Klon behaelt data-areaw und die Struktur des Originals -
     aktiviereTextGriff() braucht deshalb keine Sonderbehandlung, nur
     frisch berechnete nZeilen/deckel fuer die jeweilige Position. */
  root.lcGriffFuerKlon = function (cloneEl, p) {
    var a = CFG.flaechen[p], s = state.daten[p];
    if (!a || !s) return;
    var genutzt = s.zeilen.slice(0, a.zeilen).filter(function (t) { return t.trim().length; });
    var nZeilen = Math.max(1, genutzt.length);
    var font = CFG.schriften.filter(function (f) { return f.id === s.schrift; })[0];
    var deckel = maxGroesseFuerZeilen(nZeilen, a);
    if (genutzt.length && font) {
      genutzt.forEach(function (t) {
        var deckelB = maxGroesseFuerBreite(t, font, a, deckel);
        if (deckelB !== null && deckelB < deckel) deckel = deckelB;
      });
    }
    var textEl = cloneEl.querySelector('.sk-txt');
    if (!textEl) return;
    var feldEl = cloneEl.querySelector('.sk-field') || cloneEl;
    aktiviereTextGriff(textEl, feldEl, a, s, nZeilen, deckel, null, null);
  };

  varianteSetzen();
  alles();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { alles(); });
})();